export default __webpack_public_path__ + "static/media/forgotCircle.2cb6066e.svg";